import { Component, ChangeDetectionStrategy, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioButton } from '@angular/material/radio';
import { AvatarComponent } from '@custom-components/general/avatar/avatar.component';
import { SkeletonBlockComponent } from '@custom-components/general/skeleton/skeleton-block/skeleton-block.component';
import { Partner } from '@core/models';

@Component({
  selector: 'xemex-user-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatRadioButton,
    AvatarComponent,
    SkeletonBlockComponent,
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  userName = input<string>('');
  userAvatar = input<string>('');
  isLoading = input<boolean>(false);
  partners = input<Partner[]>([]);

  logout = output<void>();
  partnerSelect = output<Partner>();
  profileClick = output<void>();
  aboutClick = output<void>();

  activePartnerName = computed(
    () => this.partners().find(partner => partner.is_active)?.partnerName ?? '',
  );
}
